import type { DynamicOptionsLoadingProps } from "next/dynamic";
import type { PropsWithChildren } from "react";

const PassthroughFallback = ({
  children,
}: PropsWithChildren<DynamicOptionsLoadingProps>) => <>{children}</>;

export default PassthroughFallback;
